export enum NovoCategoryType {
    General = 'GENERAL',
    Psychological = 'PSYCHOLOGICAL_SAFETY',
    Motivation = 'MOTIVATION',
    Accountability = 'TEAM_MUTUAL_ACCOUNTABILITY',
    Supportive = 'SUPPORTIVE_CONTEXT',
    Complexity = 'COMPLEXITY',
}
